import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconSpeakerRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 5.998a1 1 0 0 0-1.627-.78L6.315 9.286H4.001a1 1 0 0 0-1 1v4.288a1 1 0 0 0 1 1h2.372l5.085 3.27a1 1 0 0 0 1.541-.84V5.998Zm5.823 1.775a1 1 0 1 0-1.204 1.597 3.41 3.41 0 0 1 1.379 2.631 3.413 3.413 0 0 1-1.38 2.632 1 1 0 1 0 1.205 1.597c1.328-1.002 2.143-2.546 2.175-4.21v-.038c-.032-1.664-.847-3.208-2.175-4.21Zm-2.69 1.7a1 1 0 0 0-1.158 1.63c.088.063.166.138.229.22l.007.01c.378.483.29 1.187-.245 1.576a1 1 0 0 0 1.177 1.617c1.419-1.033 1.74-3.018.647-4.42a3.072 3.072 0 0 0-.656-.633Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconSpeakerRoundFill);
export default Memo;
